import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import shop from "shop/shop"
import {observer} from "mobx-react"
import {Button, Icon, Popup, Message} from "semantic-ui-react"

import Price from "components/Price/Price"
import MinOrderValue from "components/Cart/MinOrderValue"
import queryString from "qs"

@observer
export default class ContactMessage extends Component {


    componentDidMount() {
      
    }

	render() {
		return (
            <Fragment>
                    <div>{translate( "Bitte wenden Sie sich bei aufkommenden Rückfragen direkt bei unserer Customer-Sales-Abteilung unter: ")}</div>
                                <div className="fw6 pt2 pb2">{translate( "Tel.: 0241-8881-7703")}</div>
                                <div className="fw6 pt2 pb2">E-Mail:  restanten-de@lindt.com</div>
                                <div>{translate( "Vielen Dank! ")}</div>
                </Fragment>
		)
	}
}





// WEBPACK FOOTER //
// ./src/theme/lindt/components/Messages/ContactMessage.js